<div class="banner-info-container overflox_hidden">
  <div class="container">
    <div class="pt-5">
      <h1 class="pb-3 heading">Easy Solar Financing</h1>
      <p class="pb-3">Explore seamless financing options through our partners and embrace a brighter, sustainable future with
        Luminous Solar Solutions.<span> <a #termsLink href="/terms-conditions"
          class="fs-5 terms-link text-decoration-underline">Terms & Condition</a>
     </span></p>
      <div class="row dataContainer mt-5 d-flex" *ngIf="bannerListData?.length">
        <div #carousel class="imageCarosuel position-relative">
          <owl-carousel-o [options]="customOptions">
            <ng-container *ngFor="let slideData of bannerListData">
              <ng-template carouselSlide>
                  <img loading="lazy" role="button" class="bannerImage" [src]="slideData.imageUrl" [alt]="slideData.bannerName">
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
        <div class="col-md-3 mb-5 d-flex justify-content-center align-items-center videoContainer">
          <iframe width="100%" height="345px" src="https://www.youtube.com/embed/twLEjwtKvx4?autoplay=1&rel=0&controls=0&mute=1" frameborder="0" allowfullscreen (load)="videoLoaded()"></iframe>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5 pt-5 pdfList " *ngIf="pdfListingData?.length">
    <div class="container pb-5 loan-details">
      <p class="details">Loan Details</p><br>
      <ul>
        <li><strong>Loan Amount:</strong> ₹1,00,000 to ₹4 Crore</li>
        <li><strong>Rate of Interest:</strong> 8.2% - 14%</li>
        <li><strong>Tenure:</strong> 12 - 84 Months</li>
        <li><strong>Processing Fee:</strong> 0.50% - 2%</li>
      </ul>
    </div>
    
    
    <div class="col-md-3 mt-2 mb-2 teste justify-content-center align-items-center" *ngFor="let pdfData of pdfListingData">
      <div class="pb-3 mb-1 labelTextalign">
        <span class="bankTablabel">{{ pdfData.label }}</span>
      </div>
      <div *ngFor="let bnk of pdfData.banks" 
           class="pdf-box w-100 d-flex mt-3 justify-content-center align-items-center" 
           (click)="viewPDF(bnk.pdfUrl)">
        <a [href]="bnk.pdfUrl" target="_blank">
          <!-- Check if imagePath exists -->
          <ng-container  class="pdf-box w-100 d-flex mt-3 justify-content-center align-items-center" *ngIf="bnk.imagePath; else displayText">
            <img loading="lazy" class="loan-img" [src]="bnk.imagePath" [alt]="bnk.pdfName" />
          </ng-container>
          <ng-template  class="pdf-box w-100 d-flex mt-3 justify-content-center align-items-center" #displayText>
            <h4 class="text-center m-0">{{ bnk.pdfName }}</h4>
          </ng-template>
        </a>
      </div>
    </div>
    
  </div>
</div>
